import { useScript } from "@website-builder/utilities-index";

const AdWords = (serviceConfigs, assetPrefixPath, scriptPrefixPath) => {
	useScript(`/${scriptPrefixPath}/Adwords.js`, true, "", "head");
};

export default AdWords;
